import { MDBBtn, MDBBtnGroup, MDBCheckbox, MDBDatatable, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBIcon, MDBInput } from 'mdb-react-ui-kit'
import React, { useEffect, useRef, useState } from 'react'
import { Tooltip } from 'react-tooltip';
import PopupLoaderNew from '../../popups/PopupLoaderNew';
import AuthorizedBlockUser from '../../popups/securitymanager/AuthorizedBlockUser';

function PendingUserDevice(props) {
    const [pendingUsersList, setpendingUsersList] = useState([]);
    const [pendingUserListSearch, setPendingUserListSearch] = useState([]);
    const [selectedRecord, setselectedRecord] = useState([]);
    const [allChecked, setallChecked] = useState(false);
    const [disableMulti, setdisableMulti] = useState(true);
    const [userActionList, setUserActionList] = useState([]);
    const [searchValue, setsearchValue] = useState("");
    const [finalInfo, setfinalInfo] = useState([]);
    const [actionType, setactionType] = useState(0);
    const [showPopup, setshowPopup] = useState(false);
    const togglePOPUp = () => setshowPopup(!showPopup);
    const [isLoading, setisLoading] = useState(false);
    const addUserRef = useRef(null);

    function handleClick() {
        addUserRef.current.click();
    }


    useEffect(() => {
        if (props.pendingUsers && props.pendingUsers.length > 0) {
            setPendingUserListSearch(props.pendingUsers);
            setpendingUsersList(props.pendingUsers);
        }

    }, [props.pendingUsers]);

    const handleCheckedRow = (e, selectrow) => {
        e.preventDefault();
        console.log(JSON.stringify(selectrow));
        let updatedRecordlList = [];
        let updateSelectRecord = [];

        if (e.target.checked) {
            updatedRecordlList = [...userActionList, selectrow];
            updateSelectRecord = [...selectedRecord, selectrow.id]
        } else {
            updatedRecordlList = userActionList.filter((tmdata) => tmdata.id !== selectrow.id);
            updateSelectRecord = selectedRecord.filter((tmdata) => tmdata !== selectrow.id);
        }
        const allSelected = pendingUsersList.length > 0 ? pendingUsersList.every(row => updateSelectRecord.includes(row.id)) : false;
        if (allSelected) {
            setallChecked(true);
        } else {
            setallChecked(false);
        }
        if (updatedRecordlList.length > 0) {
            setdisableMulti(false);
        } else {
            setdisableMulti(true);
        }
        setUserActionList(updatedRecordlList);
        setselectedRecord(updateSelectRecord);

    }

    const handleGlobalAction = (e, flag) => {
        handleAction(e, userActionList, flag);
    }



    const handleAction = (e, info, flag) => {
        e?.preventDefault();
        setfinalInfo([...info]);
        setactionType(flag);
        togglePOPUp();



    }



    let processdrows = [];
    pendingUsersList.map((user) => {
        processdrows.push({
            userInfo: { ...user },
            checkBoxValue: (<>
                <MDBCheckbox checked={selectedRecord.includes(user?.id)} onClick={(e) => handleCheckedRow(e, user)} />
            </>),
            username: user.user_name,
            deviceName: user.Device_name,
            lastAttemptedDate: user.last_attempted_date,
            browserName: user.browser_name,
            actions: (
                <div className="d-flex align-items-center">
                    <div className="custom-hover-bg p-1 cursor-pointer register" onClick={(e) => handleAction(e, [user], 1)}>
                        <MDBIcon far icon="registered" color="primary" className="mx-2 fs-5" />
                    </div>
                    <div className="custom-hover-bg p-1 cursor-pointer block" onClick={(e) => handleAction(e, [user], 2)}>
                        <MDBIcon fas icon="ban" color="primary" className="mx-2 fs-5" />
                    </div>
                </div>
            ),
        })
    })

    const handleAllChecked = (isChecked) => {
        if (isChecked) {
            setallChecked(true);
            setselectedRecord(pendingUsersList.map(media => media.id));
            setUserActionList(pendingUsersList);
            setdisableMulti(false);

        } else {
            setallChecked(false);
            setselectedRecord([]);
            setUserActionList([]);
            setdisableMulti(true);
        }
    }

    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUser = pendingUserListSearch.filter((user) =>
            Object.entries(user).some(([key, value]) => {
                return value?.toString().toLowerCase().includes(searchValue.toLowerCase());
            })
        );
        setpendingUsersList(filteredUser);
    };

    const actionData5 = {
        columns: [
            {
                label: (<>
                    <MDBCheckbox checked={allChecked} onChange={(e) => handleAllChecked(e.target.checked)} />
                </>), field: "checkBoxValue", sort: false
            },
            { label: 'Username', field: 'username' },
            { label: 'Device Name', field: 'deviceName' },
            { label: 'Last Attempted Date', field: 'lastAttemptedDate' },
            { label: 'Browser Name', field: 'browserName' },
            { label: 'Actions', field: 'actions' },

        ],
        rows: processdrows,
        // rows: [
        //     {
        //         username: 'udeeswara@dynamic',
        //         deviceName: 'udeeswara@dynamic',
        //         lastAttemptedDate: 'December-28-2024 05:53:13',
        //         browserName: 'Chrome',
        //     },
        //     // Add more rows as necessary
        // ].map((row) => {
        //     return {
        //         ...row,
        //         actions: (
        //             <div className="d-flex align-items-center">
        //                 <div className="custom-hover-bg p-1 cursor-pointer register">
        //                     <MDBIcon far icon="registered" color="primary" className="mx-2 fs-5" />
        //                 </div>
        //                 <div className="custom-hover-bg p-1 cursor-pointer block">
        //                     <MDBIcon fas icon="ban" color="primary" className="mx-2 fs-5" />
        //                 </div>
        //             </div>
        //         ),
        //     };
        // })
    };
    return (
        <>
            <div className="actionbar">
                {/* <MDBBtn disabled>
                    Register User(s) on Device(s)
                </MDBBtn>
                <MDBBtn className='ms-3' disabled>
                    Block User(s) on Device(s)
                </MDBBtn> */}

                <MDBBtnGroup
                    aria-label="Button group with nested dropdown"
                    className="display-inline ms-3 btn_adjust h-inherit"
                >
                    <MDBBtnGroup>
                        <MDBDropdown>
                            <MDBDropdownToggle className="px-3" disabled={disableMulti}>
                                <div className="text-white">
                                    <MDBIcon fas icon="ellipsis-v" className="me-2" />
                                    More
                                </div>
                            </MDBDropdownToggle>
                            <MDBDropdownMenu>
                                <MDBDropdownItem onClick={(e) => handleGlobalAction(e, 1)} link>Register User(s) on Device(s)</MDBDropdownItem>
                                <MDBDropdownItem onClick={(e) => handleGlobalAction(e, 2)} link>
                                    Block User(s) on Device(s)
                                </MDBDropdownItem>
                            </MDBDropdownMenu>
                        </MDBDropdown>
                    </MDBBtnGroup>
                </MDBBtnGroup>
            </div>
            <div className='mb-2 mt-3 position-relative w-auto'>
                <MDBInput label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
            <div className="SecutityTopViewPage1 selectableRows">
                <MDBDatatable hover data={actionData5} sortField="Username" sortOrder="asc" entries={50} />
            </div>

            <Tooltip anchorSelect=".block" place="top" className="exampleTooltip">
                Block User(s) on Device(s)
            </Tooltip>

            <Tooltip anchorSelect=".register" place="top" className="exampleTooltip">
                Register User(s) on Device(s)
            </Tooltip>

            {showPopup && (
                <PopupLoaderNew
                    title={actionType === 1 ? "Register User(s) on Device(s)" : "Block User(s) on Device(s)"}
                    content={<AuthorizedBlockUser
                        userInfoList={finalInfo}
                        onClose={togglePOPUp}
                        ref={addUserRef}
                        setIsloading={setisLoading}
                        actionType={actionType}
                    />}
                    onShow={setshowPopup}
                    onClose={togglePOPUp}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={1}
                />
            )}

        </>
    )
}

export default PendingUserDevice
